<template>
  <footer class="footer">
    <div class="page-footer">
      <LazyWidgetsSystemBreadcrumbs
        :data="{
          isCenter: true,
          parentClasses: 'py-4 default isDarkMode dark:bg-sky-800 dark:text-white'
        }"
      />

      <FooterContacts />

      <FooterMain />

      <FooterCopyright />
    </div>
  </footer>
</template>

<script setup>

</script>

<style lang="scss">
</style>
